module.exports = __webpack_public_path__ + "static/media/Portals.402d4a70.svg";